/// Converts the api unit type to a value assets and translations can use.
const parseUnitTypeForAssets = (apiType) => {
  switch (apiType) {
    case 'lan_adapter':
      return 'wlanadapter'
    case 'solar_pump':
      return 'solarpump'
  }

  return apiType
}

const parseSerialToMacAddress = (serial) => {
  let localValue = null
  if (serial?.length) {
    localValue = serial.match(/.{1,2}/g).join(':')
  }
  return localValue
}

const unitsFromQuery = (query, macAddressRequired) => {
  const results = []
  if (query.adapter_model && query.adapter_serial) {
    results.push({
      material: query.adapter_model,
      serial: macAddressRequired
        ? parseSerialToMacAddress(query.adapter_serial)
        : query.adapter_serial
    })
  }
  if (query.indoor_model && query.indoor_serial) {
    results.push({
      material: query.indoor_model,
      serial: query.indoor_serial
    })
  }
  return results
}

export default function(ctx, inject) {
  const startRegistration = async (gatewayDeviceId) => {
    await ctx.store.dispatch('registration/clearRegistration')
    if (gatewayDeviceId) {
      await ctx.store.dispatch(
        'registration/setGatewayDeviceId',
        gatewayDeviceId
      )
    }
    return ctx.app.router.push({ name: 'registration-scan-units-start' })
  }
  inject('startRegistration', startRegistration)
  ctx.$startRegistration = startRegistration

  inject('parseUnitTypeForAssets', parseUnitTypeForAssets)
  ctx.$parseUnitTypeForAssets = parseUnitTypeForAssets

  inject('unitsFromQuery', unitsFromQuery)
  ctx.$unitsFromQuery = unitsFromQuery

  inject('parseSerialToMacAddress', parseSerialToMacAddress)
  ctx.$parseSerialToMacAddress = parseSerialToMacAddress

  const parseCustomerDetails = () => {
    let customerDetails = []
    switch (ctx.$storage.getUniversal('account').country) {
      case 'IT':
      case 'ES':
        customerDetails = ['fiscal_number']
        break
      case 'GR':
        customerDetails = ['fiscal_number', 'tax_office']
        break
    }

    return customerDetails
  }

  inject('parseCustomerDetails', parseCustomerDetails)
  ctx.$parseCustomerDetails = parseCustomerDetails

  const startRegistrationWithUnits = async (units, gatewayDeviceId) => {
    await ctx.store.dispatch('registration/clearRegistration')
    ctx.$sentry.addBreadcrumb({
      category: 'registration',
      level: 'info',
      message: 'Start registration with units',
      data: {
        units
      }
    })

    try {
      if (gatewayDeviceId) {
        await ctx.store.dispatch(
          'registration/setGatewayDeviceId',
          gatewayDeviceId
        )
      }
      const result = await ctx.$marlonApi.validateUnit(units)
      ctx.$sentry.addBreadcrumb({
        category: 'registration',
        level: 'info',
        message: 'validation result',
        data: {
          result
        }
      })
      if (result?.validation_status === 'valid') {
        for (const unit of units) {
          if (!unit.material || !unit.serial) {
            console.log('skipping incomplete unit', unit)
            ctx.$sentry.addBreadcrumb({
              category: 'registration',
              level: 'info',
              message: 'skipping incomplete unit',
              data: {
                unit
              }
            })
            continue
          }
          await ctx.store.dispatch('registration/addScannedUnit', {
            serial: unit.serial,
            material: unit.material
          })
        }

        // const overview = ctx.store.dispatch('')
        const oUnits = await ctx.store.dispatch(
          'registration/getUnitsForOverview'
        )
        const productRange = ctx.$storage.getUniversal(
          'scan-units.product-range'
        )
        if (productRange && oUnits.length) {
          return ctx.app.router.push({
            name: 'registration-scan-units-overview'
          })
        }
        ctx.$sentry.addBreadcrumb({
          category: 'registration',
          level: 'info',
          message: 'None of the units were available for the overview'
        })
      } else if (result?.validation_status === 'already_registered') {
        ctx.$storage.setUniversal('scan-units.existing', result)
        if (result?.resend_invitation_email) {
          return ctx.app.router.push({
            name: 'registration-scan-units-check-invitation-unit'
          })
        } else {
          return ctx.app.router.push({
            name: 'registration-scan-units-not-your-unit'
          })
        }
      }
    } catch (err) {
      ctx.$sentry.setExtra(
        'Unit validation has failed while registering units',
        err
      )
      ctx.$sentry.captureException(err)
    }

    // if we are here, unit validation has failed invalid_url
    ctx.$sentry.captureMessage(
      'Unit validation failed, unsupported flow',
      'error'
    )
    return ctx.app.router.push({
      name: 'landing',
      query: { state: 'invalid_url' }
    })
  }

  inject('startRegistrationWithUnits', startRegistrationWithUnits)
  ctx.$startRegistrationWithUnits = startRegistrationWithUnits
}
